import React from "react";

import FieldProto from "../../../../proto/field-proto"

type Props = {
    parent  : any,
    field   : FieldProto
}

export default class UserSkillsPopoverMenuMore extends React.Component<Props> {
    render() {
        return (
            <div className="help">
                <div className="ui5-link-small" onClick={()=>{
                    this.props.parent.hidePopover()
                    gd.goTo('settings/user-skills')
                }}>
                    Edit options
                </div>
            </div>
        );
    }
}